<template>
  <div>
    <v-tooltip bottom>
      <template #activator="data">
        <v-btn icon v-on="data.on" @click="open()">
          <v-icon>mdi-file-export</v-icon>
        </v-btn>
      </template>
      <span>{{ $t('recherche.export.title.menu') }}</span>
    </v-tooltip>
    <v-dialog persistent v-model="showDialog" fullscreen>
      <v-toolbar dark color="primary">
        <v-btn icon dark @click="close()">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>{{
          $t('recherche.export.title.' + typeObjet)
        }}</v-toolbar-title>
      </v-toolbar>
      <v-card>
        <v-row dense>
          <v-col cols="12" md="3">
            <mesExports
              :typeObjet="this.typeObjet"
              @select="select($event)"
              ref="mesExports"
            />
          </v-col>
          <v-col cols="12" md="9">
            <criteresExport
              :typeObjet="this.typeObjet"
              @close="close()"
              @exporter="exporter($event)"
              @save="save($event)"
              @remove="remove($event)"
              ref="criteresExport"
            />
            <v-dialog v-model="waitForExport" persistent max-width="50%">
              <v-card>
                <v-card-title class="accent white--text">
                  <v-icon color="white">mdi-clock</v-icon>Export en cours
                </v-card-title>
                <v-card-text class="body-1">
                  <p class="pt-4">
                    Votre document est en cours de préparation.
                  </p>
                  <p>
                    Veuillez patienter quelques secondes.
                  </p>
                  <v-progress-linear
                    color="primary"
                    indeterminate
                    rounded
                    striped
                    height="6"
                  ></v-progress-linear>
                </v-card-text>
              </v-card>
            </v-dialog>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { saveAs } from 'file-saver';
import toasted from '@/utils/toasted';
import arraybufferToResponse from '@/utils/errors';

export default {
  props: {
    // contact | personneMorale | instance | contactExpire
    typeObjet: {
      type: String,
    },
    // simple | avancee
    typeRecherche: {
      type: String,
    },
    datasourceContact: {
      type: Object,
    },
    datasourcePersonneMorale: {
      type: Object,
    },
    datasourceInstance: {
      type: Object,
    },
    datasourceContactExpire: {
      type: Object,
    },
    selectedContact: {
      type: Array,
    },
    selectedPersonneMorale: {
      type: Array,
    },
    selectedInstance: {
      type: Array,
    },
  },
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},

  data() {
    return {
      // Affichage de la boîte de dialogue
      showDialog: false,
      // Boîte de dialogue opur l'export
      waitForExport: false,
    };
  },
  computed: {},
  watch: {},
  methods: {
    // Lien Criteres -> MesExports
    save(mesExports) {
      this.$refs.mesExports.save(mesExports);
    },
    remove(idMesExports) {
      this.$refs.mesExports.remove(idMesExports);
    },
    // Lien MesExports -> Criteres
    select(mesExports) {
      this.$refs.criteresExport.select(mesExports);
    },
    // Gestion de la dialog des critères
    open() {
      if (this.$refs.mesExports) {
        this.$refs.mesExports.show();
      }
      this.showDialog = true;
    },
    close() {
      this.showDialog = false;
    },
    exporter(criteres) {
      var params = Object.assign({}, criteres);
      var pagination = null;
      var selected = [];

      var ds = null;
      var uri = null;
      switch (this.typeObjet) {
        case 'contact':
          ds = this.datasourceContact;
          selected = this.selectedContact;
          uri = 'recherche/' + this.typeRecherche + '/export/contact';
          break;
        case 'personneMorale':
          ds = this.datasourcePersonneMorale;
          selected = this.selectedPersonneMorale;
          uri = 'recherche/' + this.typeRecherche + '/export/personne-morale';
          break;
        case 'instance':
          ds = this.datasourceInstance;
          selected = this.selectedInstance;
          uri = 'recherche/' + this.typeRecherche + '/export/instance';
          break;
        case 'contactExpire':
          ds = this.datasourceContactExpire;
          uri = 'recherche/' + this.typeRecherche + '/export/contactExpire';
          break;
      }
      if (ds) {
        params.search = this.typeRecherche == 'avancee' ? ds.body : ds.args;
        if (criteres.scope === 'selection') {
          params.ids = selected.flatMap(s => s.id);
        }
        if (ds.pagination.sortBy && ds.pagination.sortBy.length > 0) {
          pagination = {
            page: 0,
            size: 0,
            sort:
              ds.pagination.sortBy[0] +
              ',' +
              (ds.pagination.descending[0] ? 'DESC' : 'ASC'),
          };
        }
      }
      if (
        this.typeRecherche == 'avancee' &&
        (!params.search ||
          !Array.isArray(Object.keys(params.search)) ||
          Object.keys(params.search).length == 0)
      ) {
        toasted.error('recherche.export.error.noSearch');
      } else {
        this.waitForExport = true;
        return this.$api(uri)
          .post(params, { params: pagination, responseType: 'arraybuffer' })
          .then(
            response => {
              this.erreurExport = '';
              let contentType = response.headers.get('content-type');
              let contentDisposition = response.headers.get(
                'content-disposition',
              );
              if (
                contentDisposition &&
                contentDisposition.indexOf('attachment') !== -1
              ) {
                const regex = /filename="([^"]+)"/;
                let match = contentDisposition.match(regex);
                if (match) {
                  let blob = new Blob([response.data], { type: contentType });
                  saveAs(blob, match[1]);
                } else {
                  toasted.error('recherche.export.error.noFilename');
                }
              } else {
                toasted.error('recherche.export.error.noAttachment');
              }
            },
            response => {
              var jsonResponse = arraybufferToResponse(response);
              if (jsonResponse && jsonResponse.status) {
                toasted.error(
                  this.$t('recherche.export.error.serverErrorWithStatus', {
                    status: jsonResponse.status,
                  }),
                );
              } else {
                toasted.error(this.$t('recherche.export.error.serverError'));
              }
            },
          )
          .finally(() => {
            this.waitForExport = false;
          });
      }
    },
  },
};
</script>
